import React from 'react';
import PropTypes from 'prop-types';
import { getStatusClass } from '../../../utils/utils';
import styles from './Overview.css';

const Overview = ({ scanner }) => {
  return (
    <div className={styles.detailSection} data-test-id="scan-overview-section">
      <h2>Scan Overview</h2>
      <div className={styles.detailSectionContent}>
        <div className={styles.infoGrid} data-test-id="scanner-name">
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Name</span>
            <span>{scanner.name}</span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-connection">
            <span className={styles.infoLabel}>Connection</span>
            <span>{scanner.connectionName}</span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-status">
            <span className={styles.infoLabel}>Status</span>
            <span
              className={`${styles.statusBadge} ${getStatusClass(scanner.state, styles)}`}
            >
              {scanner.state || '-'}
            </span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-duration">
            <span className={styles.infoLabel}>Duration</span>
            <span data-test-id="scanner-duration">1m 5s</span>
          </div>
        </div>
      </div>
    </div>
  );
};

Overview.propTypes = {
  scanner: PropTypes.shape({
    name: PropTypes.string.isRequired,
    connectionName: PropTypes.string.isRequired,
    state: PropTypes.oneOf(['SUCCESS', 'CLOSE', 'Running', 'Idle', 'Error'])
  })
};

export default Overview;
